// © Microsoft Corporation. All rights reserved.
import React, { Fragment, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Spinner } from '@fluentui/react';
import VideocamIcon from '@material-ui/icons/Videocam';
import Check from '@material-ui/icons/Check';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import {
  localStorageAvailable,
  getDisplayIMOFromLocalStorage,
  saveDisplayIMOToLocalStorage,
  getDisplayHEXIDFromLocalStorage,
  saveDisplayHEXIDToLocalStorage,
  getDisplayMMSIFromLocalStorage,
  saveDisplayMMSIToLocalStorage
} from '../Utils/localStorage';
import { sendMessage, saveAdditonalInfo } from '../core/chatSideEffects';
import { State } from '../core/reducers';
import { setAddIfo } from '../core/actions/ThreadAction';

const mapStateToProps = (state: State) => ({
  addInfo: state.thread.addInfo,
});

const mapDispatchToProps = (dispatch: any) => ({
  onSendMessage: (messageContent: string) => dispatch(sendMessage(messageContent)),
  setAddInfo: (info: object) => {
    dispatch(setAddIfo(info));
  },
});

const useStyles = makeStyles((theme) => ({
  field: {
    width: '100%'
  },
  fieldnamepanel1: {
    width: '100%',
    fontSize: '24px',
    fontFamily: 'Segoe UI',
  },
  fristnamepanelm1: {
    height: '64px',
    fontFamily: 'Segoe UI',
  },
  emaifristnamepanelm1: {
    height: '64px',
    fontFamily: 'Segoe UI',
  },
  buttonsagreepanelm1: {
    marginTop: '4px',
    textAlign: 'center',
  },
  // buttonLoginColor: {
  //   background: '#66B2B2',
  //   textTransform: "none",
  //   '&:hover': {
  //     background: props.darkColor,
  //   },
  // },
  gridSpacing: {
    margin: 0,
    padding: 10
  },
  spinner: {
    width: '20px !important',
    height: '20px !important'
  }
}));

const FormOtional = (props: any): JSX.Element => {
  // console.log(props.addInfo, 'props')
  const theme: any = useTheme();
  const classes = useStyles();
  // Get display IMO number from local storage if available
  // const defaultDisplayIMO = localStorageAvailable ? getDisplayIMOFromLocalStorage() : null;
  const [displayIMO, setDisplayIMO] = useState<string | undefined>('' ?? undefined);
  // Get display HEX ID from local storage if available
  // const defaultDisplayHEXID = localStorageAvailable ? getDisplayHEXIDFromLocalStorage() : null;
  const [displayHEXID, setDisplayHEXID] = useState<string | undefined>('' ?? undefined);
  // Get display MMSI from local storage if available
  // const defaultDisplayMMSI = localStorageAvailable ? getDisplayMMSIFromLocalStorage() : null;
  const [displayMMSI, setDisplayMMSI] = useState<string | undefined>('' ?? undefined);
  const [iloader, setILoader] = useState(false);
  const [hloader, setHLoader] = useState(false);
  const [mloader, setMLoader] = useState(false);
  const [inputname, setName] = useState('');

  useEffect(() => {
    if (props.addInfo) {
      if (inputname !== 'displayIMONumber') {
        setDisplayIMO(props.addInfo.imoNumber)
      }
      if (inputname !== 'displayHEXID') {
        setDisplayHEXID(props.addInfo.hexaNumber)
      }
      if (inputname !== 'displayMMSINumber') {
        setDisplayMMSI(props.addInfo.mmsiNumber)
      }
    }
  }, [props.addInfo])

  const onValueChange = (e: any) => {
    const name = e.target.name;
    // console.log(name)
    setName(name)
    const newValue = e.target.value;
    if (name === 'displayIMONumber') {
      setDisplayIMO(newValue);
      // props.setAddInfo({ imoNumber: newValue, hexaNumber: displayHEXID, mmsiNumber: displayMMSI });
      // saveDisplayIMOToLocalStorage(newValue);
    } else if (name === 'displayHEXID') {
      setDisplayHEXID(newValue);
      // props.setAddInfo({ imoNumber: displayIMO, hexaNumber: newValue, mmsiNumber: displayMMSI });
      // saveDisplayHEXIDToLocalStorage(newValue);
    } else if (name === 'displayMMSINumber') {
      setDisplayMMSI(newValue);
      // props.setAddInfo({ imoNumber: displayIMO, hexaNumber: displayHEXID, mmsiNumber: newValue });
      // saveDisplayMMSIToLocalStorage(newValue);
    }
  };

  const onValueBlur = async (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    if (newValue === undefined || !newValue) {
      if (name === 'displayIMONumber') {
        props.setAddInfo({ imoNumber: newValue, hexaNumber: displayHEXID, mmsiNumber: displayMMSI });
        saveDisplayIMOToLocalStorage(newValue);
        setILoader(true);
        await saveAdditonalInfo('IMONumber__c', newValue);
        setILoader(false);
        setName('')
      } else if (name === 'displayHEXID') {
        props.setAddInfo({ imoNumber: displayIMO, hexaNumber: newValue, mmsiNumber: displayMMSI });
        saveDisplayHEXIDToLocalStorage(newValue);
        setHLoader(true);
        await saveAdditonalInfo('HEXID__c', newValue);
        setHLoader(false);
        setName('')
      } else if (name === 'displayMMSINumber') {
        props.setAddInfo({ imoNumber: displayIMO, hexaNumber: displayHEXID, mmsiNumber: newValue });
        saveDisplayMMSIToLocalStorage(newValue);
        setMLoader(true);
        await saveAdditonalInfo('MMSINumber__c', newValue);
        setMLoader(false);
        setName('')
      }
      return;
    }
    if (name === 'displayIMONumber') {
      const text = 'IMO Number : ' + '' + newValue;
      saveDisplayIMOToLocalStorage(newValue);
      if (props.addInfo) {
        if (props.addInfo.imoNumber) {
          if (props.addInfo.imoNumber !== newValue) {
            setILoader(true);
            await saveAdditonalInfo('IMONumber__c', newValue);
            props.onSendMessage(text);
            setILoader(false);
            setName('')
          }
        } else {
          setILoader(true);
          await saveAdditonalInfo('IMONumber__c', newValue);
          props.onSendMessage(text);
          setILoader(false);
          setName('')
        }
      } else {
        setILoader(true);
        await saveAdditonalInfo('IMONumber__c', newValue);
        props.onSendMessage(text);
        setILoader(false);
        setName('')
      }
      props.setAddInfo({ imoNumber: newValue, hexaNumber: displayHEXID, mmsiNumber: displayMMSI });
    } else if (name === 'displayHEXID') {
      const text = 'HEX ID : ' + '' + newValue;
      saveDisplayHEXIDToLocalStorage(newValue);
      if (props.addInfo) {
        if (props.addInfo.hexaNumber) {
          if (props.addInfo.hexaNumber !== newValue) {
            setHLoader(true);
            await saveAdditonalInfo('HEXID__c', newValue);
            props.onSendMessage(text);
            setHLoader(false);
            setName('')
          }
        } else {
          setHLoader(true);
          await saveAdditonalInfo('HEXID__c', newValue);
          props.onSendMessage(text);
          setHLoader(false);
          setName('')
        }
      } else {
        setHLoader(true);
        await saveAdditonalInfo('HEXID__c', newValue);
        props.onSendMessage(text);
        setHLoader(false);
        setName('')
      }
      props.setAddInfo({ imoNumber: displayIMO, hexaNumber: newValue, mmsiNumber: displayMMSI });
    } else if (name === 'displayMMSINumber') {
      const text = 'MMSI Number : ' + '' + newValue;
      saveDisplayMMSIToLocalStorage(newValue);
      if (props.addInfo) {
        if (props.addInfo.mmsiNumber) {
          if (props.addInfo.mmsiNumber !== newValue) {
            setMLoader(true);
            await saveAdditonalInfo('MMSINumber__c', newValue);
            props.onSendMessage(text);
            setMLoader(false);
            setName('')
          }
        } else {
          setMLoader(true);
          await saveAdditonalInfo('MMSINumber__c', newValue);
          props.onSendMessage(text);
          setMLoader(false);
          setName('')
        }
      } else {
        setMLoader(true);
        await saveAdditonalInfo('MMSINumber__c', newValue);
        props.onSendMessage(text);
        setMLoader(false);
        setName('')
      }
      props.setAddInfo({ imoNumber: displayIMO, hexaNumber: displayHEXID, mmsiNumber: newValue });
    }
  };

  const customrender = (label?: string): any => {
    return (
      <Fragment>
        {label}<span style={{ marginLeft: '5px', fontSize: '12px', fontStyle: 'italic' }}></span>
      </Fragment>
    )
  }
  // console.log(displayIMO, displayHEXID, displayMMSI)
  return (
    <Fragment>
      <div style={{ margin: '4px 0 0 10px', fontWeight: '500' }}>Please provide any information that you have</div>
      <Grid container spacing={1} className={classes.gridSpacing}>
        <Grid className={classes.fristnamepanelm1} item xs={12} md={12}>
          <TextField
            id="standard-basic"
            label={customrender("IMO Number")}
            // label="IMO Number"
            name="displayIMONumber"
            variant="standard"
            InputLabelProps={{ style: { fontSize: '14px', color: props.darkColor } }}
            InputProps={{
              style: { fontSize: '18px', color: '#707070' },
              endAdornment: iloader ? <CircularProgress style={{ color: props.darkColor, width: '30px', height: '30px' }} /> : (getDisplayIMOFromLocalStorage() ? <Check style={{ color: props.darkColor }} /> : '')
            }}
            className={classes.fieldnamepanel1}
            onChange={(e) => onValueChange(e)}
            onBlur={(e) => onValueBlur(e)}
            // defaultValue={displayIMO}
            value={displayIMO}
          />
        </Grid>
        <Grid className={classes.fristnamepanelm1} item xs={12} md={12}>
          <TextField
            id="standard-basic"
            label={customrender("HEX ID")}
            // label="HEX ID"
            name="displayHEXID"
            variant="standard"
            InputLabelProps={{ style: { fontSize: '14px', color: props.darkColor } }}
            InputProps={{
              style: { fontSize: '18px', color: '#707070' },
              endAdornment: hloader ? <CircularProgress style={{ color: props.darkColor, width: '30px', height: '30px' }} /> : (getDisplayHEXIDFromLocalStorage() ? <Check style={{ color: props.darkColor }} /> : '')
            }}
            className={classes.field}
            onChange={(e) => onValueChange(e)}
            onBlur={(e) => onValueBlur(e)}
            // defaultValue={displayHEXID}
            value={displayHEXID}
          />
        </Grid>
        <Grid className={classes.emaifristnamepanelm1} item xs={12} md={12}>
          <TextField
            id="standard-basic"
            // label="MMSI Number"
            label={customrender("MMSI Number")}
            name="displayMMSINumber"
            variant="standard"
            InputLabelProps={{ style: { fontSize: '14px', color: props.darkColor } }}
            InputProps={{
              style: { fontSize: '18px', color: '#707070' },
              endAdornment: mloader ? <CircularProgress style={{ color: props.darkColor, width: '30px', height: '30px' }} /> : (getDisplayMMSIFromLocalStorage() ? <Check style={{ color: props.darkColor }} /> : '')
            }}
            className={classes.field}
            onChange={(e) => onValueChange(e)}
            onBlur={(e) => onValueBlur(e)}
            // defaultValue={displayMMSI}
            value={displayMMSI}
          />
        </Grid>
        {/* <Grid className={classes.buttonsagreepanelm1} item xs={12} md={12}>
          <Button
            variant="contained"
            // startIcon={<VideocamIcon />}
            color="secondary"
            className={classes.buttonLoginColor}
            onClick={() => clickConnectNow()}
          >
            Submit
          </Button>
        </Grid> */}
      </Grid>
    </Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(FormOtional);